import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgFor, DatePipe, NgIf } from '@angular/common';
import { ApplicationService } from '../../services/application.service';
import { SessionService } from '../../services/session.service';
import { SessionInfo } from '../../models/sessioninfo';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { PERMISSIONS } from '../../models/constants';
import { Player } from '../../models/player';

@Component({
  selector: 'app-sessions',
  standalone: true,
  imports: [NgFor, NgIf, DatePipe, FormsModule],
  templateUrl: './sessions.component.html',
  styleUrl: './sessions.component.css'
})

export class SessionsComponent implements OnInit {
  constructor(private applicationService:ApplicationService, private sessionService:SessionService, private authService:AuthenticationService, private router:Router) {
    this.loggedInUserIsAdmin = this.authService.isAdmin();
    
  }

  async ngOnInit(): Promise<void> {
    this.canManageOtherSessions = await this.authService.userHasPermission(PERMISSIONS.MANAGEOTHERSESSIONS);
    await this.getPlayers();
    await this.getSessionsForSelectedUser();
  }

  async getPlayers() {
    this.users = await this.authService.getAllPlayers();
    this.selectedUsername = this.authService.getLoggedInUsername();
  }

  loggedInUserIsAdmin:boolean;
  selectedUsername:string = '';
  sessions:Array<SessionInfo> = [];
  canManageOtherSessions:boolean = false;
  users:Array<Player> = [];

  async getSessionsForSelectedUser() {
    this.applicationService.showGlobalSpinner();
    this.sessions = await this.sessionService.searchSessions(this.selectedUsername);
    this.applicationService.hideGlobalSpinner();
  }

  onSessionClick(session: SessionInfo) {
    this.router.navigate([`/session/${session.id}`]);
  }

  // Add this method
  trackByDate(index: number, item: SessionInfo): string {
    let dte = item.sessionDate as Date;
    return dte.toString();
  }

  newSession() {
    this.router.navigate(['/createsession']);
  }
}
